<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row dense>
          <!-- 1. Trạng thái -->
          <v-col cols="12" md="4">
            <v-select
              v-model="status"
              :items="statusList"
              label="Trạng thái"
              outlined
              dense
              clearable
              hide-details
              placeholder="Tất cả trạng thái"
              @change="onFilterChanged"
            />
          </v-col>

          <!-- 2. Tìm kiếm từ khóa (Mã, Tiêu đề, Người thực hiện) -->
          <v-col cols="12" md="8">
            <v-text-field
              v-model="keyword"
              label="Mã đợt, tiêu đề hoặc người thực hiện"
              placeholder="Nhập mã đợt, tiêu đề hoặc người thực hiện..."
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        TÌM KIẾM
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditFilter',
  data: () => ({
    status: '',
    keyword: '',
    statusList: [
      { text: 'Tất cả trạng thái', value: '' },
      { text: 'Bản nháp', value: 'DRAFT' },
      { text: 'Đang kiểm kê', value: 'IN_PROGRESS' },
      { text: 'Đã hoàn thành', value: 'COMPLETED' }
    ]
  }),
  mounted() {
    this.onFilterChanged()
  },
  methods: {
    onFilterChanged() {
      const params = {}
      if (this.status) params.status = this.status
      if (this.keyword && this.keyword.trim()) {
        params.keyword = this.keyword.trim()
      }
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;
  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
